import { css, cx } from "@emotion/css"
import { Box, IconButton, Menu, MenuItem } from "@material-ui/core"
import { useState, useRef } from "react"
import { exportTable } from "../../api"
import { ReactComponent as IconExport } from "assets/icon-export.svg"
import { ReactComponent as ArrowDropDownItem } from "assets/arrow-drop-down.svg"
import { Link } from "react-router-dom"

export const ExportButton = ({
  search,
  type,
}: {
  search: string
  type: "gcf" | "nonGCF"
}) => {
  const downloadRef = useRef<HTMLAnchorElement | null>(null)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const onExport = async () => {
    exportTable(type, { filters: search })
      .then((res) => {
        const objectUrl = URL.createObjectURL(res)
        if (downloadRef.current) {
          downloadRef.current.href = objectUrl
          downloadRef.current.click()
        }

        return objectUrl
      })
      .then((orl) => {
        URL.revokeObjectURL(orl)
      })
      .catch((err) => {
        console.log("err::", err)
      })
    handleClose()
  }

  return (
    <Box>
      <a
        ref={downloadRef}
        className="visually-hidden"
        download={`${type}-report.xlsx`}
        href={"#ohno"}
      >
        export
      </a>

      <IconButton className={cx(stylesRevenue.btn)} onClick={handleClick}>
        <IconExport />
        <div className={cx(stylesRevenue.txt)}>Export</div>
        <ArrowDropDownItem />
      </IconButton>

      <Menu
        elevation={0}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: -50,
          horizontal: "center",
        }}
        className={stylesRevenue.menuBox}
      >
        <MenuItem onClick={onExport}>Quick Export</MenuItem>
        <MenuItem>
          <Link to={`/reporting${search}`}>Report Builder Export</Link>
        </MenuItem>
      </Menu>
    </Box>
  )
}

const stylesRevenue = {
  btn: css`
    background-color: var(--white);
    border-radius: 20px;
    width: 146px;
    height: 32px;
    color: var(--primary-main-green);
    border: 1px solid var(--primary-main-green);
    &:hover {
      cursor: pointer;
      color: var(--primary-main-green);
      background-color: var(--white);
    }
    .MuiIconButton-label {
      display: flex;
      justify-content: space-between;
    }
  `,
  txt: css`
    font-weight: 700;
    font-style: normal;
    font-size: 13px;
    width: 51px;
  `,
  menuBox: css`
    .MuiPaper-root {
      background: var(--extra-dark-grey-2);
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.4);
    }
    .MuiMenu-list {
      display: flex;
      width: 173px;
      padding: 8px;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
    .MuiMenuItem-root {
      display: flex;
      height: 32px;
      padding: 8px 0px 8px 8px;
      align-items: center;
      gap: 8px;
      align-self: stretch;
      color: var(--white);
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 124%;
      :hover {
        background-color: var(--extra-dark-grey);
      }
    }
    ul > li > a {
      text-decoration: none;
      color: var(--white);
    }
  `,
}
